import { Button } from "../components/ui/button";
import { cn } from "../lib/utils";

function ButtonIcon({ children, className, ...props }) {
  return (
    <Button
      className={cn("[&_svg]:size-5 transition-all duration-200 ", className)}
      {...props}
    >
      {children}
    </Button>
  );
}

export default ButtonIcon;
